// Generated from "Everything You Need to Know About IMPROVE.docx" (Steve, 15 Sep
// 2026) by scratchpad/build_faq.py. Every paragraph of the document is here, in
// its order and structure; edit the document and regenerate rather than editing
// this file by hand. Ranges use "to" (house style), dashes in the source became
// commas or colons.
export default {
  "intro": "Whether you’re looking to improve onboarding, compliance or employee development, we’ve answered the questions we’re most commonly asked to help you decide if IMPROVE is right for your organisation.",
  "sections": [
    {
      "title": "About IMPROVE",
      "items": [
        {
          "question": "What is IMPROVE?",
          "answer": "<p>IMPROVE is an online learning platform built specifically for growing businesses. It brings onboarding, compliance training and employee development together in one simple, easy-to-use platform.</p>"
        },
        {
          "question": "Who is IMPROVE designed for?",
          "answer": "<p>IMPROVE is ideal for organisations with 5 to 250 employees. It’s used by business owners, HR teams, operations managers and learning professionals who want a simple way to manage employee training.</p>"
        },
        {
          "question": "What problems does IMPROVE solve?",
          "answer": "<p>Many growing businesses struggle with:</p><ul><li>Inconsistent onboarding</li><li>Managers repeating the same training</li><li>Difficulty tracking compliance</li><li>Training records spread across multiple systems</li><li>Limited visibility of employee progress</li><li>Lack of structured employee development</li></ul><p>IMPROVE brings everything together in one place, making training easier to manage, more consistent and easier to monitor across your organisation.</p>"
        },
        {
          "question": "Why choose IMPROVE?",
          "answer": "<p>Unlike many learning platforms, IMPROVE has been designed specifically for SMEs.</p><p>It’s simple to use, affordable to implement and quick to get started, helping organisations save management time while creating a more consistent learning experience for every employee.</p>"
        }
      ]
    },
    {
      "title": "Features & Content",
      "items": [
        {
          "question": "What can I use IMPROVE for?",
          "answer": "<p>Most organisations use IMPROVE for:</p><ul><li>Employee onboarding</li><li>Compliance and mandatory training</li><li>Employee development</li><li>Management development</li><li>Company policies and procedures</li><li>Training records and reporting</li><li>Sharing knowledge across the business</li></ul>"
        },
        {
          "question": "Can I upload my own training?",
          "answer": "<p>Yes.</p><p>You can upload your own courses, videos, PDFs, documents, policies, procedures and learning resources to create a platform that’s completely tailored to your organisation.</p>"
        },
        {
          "question": "Does IMPROVE include ready-made training?",
          "answer": "<p>Yes.</p><p>Every platform includes access to a growing library of 130+ online learning courses, and you can combine these with your own training materials to create a complete learning solution.</p>"
        },
        {
          "question": "Can employees access IMPROVE anywhere?",
          "answer": "<p>Yes.</p><p>Employees can access IMPROVE on desktop, laptop, tablet or mobile, making learning available wherever they work.</p>"
        },
        {
          "question": "Can I create learning pathways?",
          "answer": "<p>Yes.</p><p>You can create structured learning journeys for new starters, managers, departments or specific job roles, ensuring everyone completes the right training at the right time.</p>"
        }
      ]
    },
    {
      "title": "Pricing & Purchasing",
      "items": [
        {
          "question": "How much does IMPROVE cost?",
          "answer": "<p>Our pricing is simple and transparent.</p><p><strong>1 to 50 Users</strong></p><p>Year 1: £995</p><p>Years 2 &amp; 3: £1,695 per year</p><p><strong>51 to 100 Users</strong></p><p>Year 1: £1,695</p><p>Years 2 &amp; 3: £2,495 per year</p><p><strong>101 to 250 Users</strong></p><p>Year 1: £2,995</p><p>Years 2 &amp; 3: £3,995 per year</p><p>All IMPROVE subscriptions are based on a three-year agreement, giving you predictable costs while allowing you to embed learning across your organisation.</p><p>During your subscription you’ll receive newly released courses at no additional cost, while existing courses are continually updated to reflect the latest legislation and best practice.</p><p>There are no hidden licence fees.</p><p>Every package includes unlimited use of the platform and all included learning content for every employee within your chosen user band.</p><p>These are our October 2026 prices. Once you sign, your prices are fixed for your three year agreement.</p><p>You can pay by card at checkout or ask to be invoiced, with 30 day payment terms and payment by bank transfer or card.</p>"
        },
        {
          "question": "Are there any additional costs?",
          "answer": "<p>Every customer completes our IMPROVE Launch Programme, designed to ensure you’re set up for success from day one.</p><p>The programme includes:</p><ul><li>Platform configuration</li><li>Launch planning</li><li>Online onboarding session</li><li>Guidance from one of our Customer Success Managers</li></ul><p>The Launch Programme is a one-off investment of £695 + VAT.</p>"
        },
        {
          "question": "Can I buy IMPROVE online?",
          "answer": "<p>Yes.</p><p>Simply choose the package that matches your organisation, complete your purchase securely online and we’ll guide you through the next steps.</p>"
        },
        {
          "question": "Can I request a quote?",
          "answer": "<p>Absolutely.</p><p>If your organisation requires a quotation before purchasing, simply email <a href=\"mailto:info@improve.online\">info@improve.online</a> and we’ll prepare one for you.</p>"
        },
        {
          "question": "What payment methods do you accept?",
          "answer": "<p>You can purchase securely online using major debit and credit cards.</p><p>If you require payment by invoice, simply contact us before completing your purchase.</p>"
        }
      ]
    },
    {
      "title": "Getting Started",
      "items": [
        {
          "question": "Can I try IMPROVE before I buy?",
          "answer": "<p>Yes.</p><p>Request a free trial through our website and explore the platform at your own pace.</p><p>During your trial you’ll also be invited to join one of our live webinars where we’ll demonstrate the platform and answer your questions.</p>"
        },
        {
          "question": "How quickly can we get started?",
          "answer": "<p>Most organisations can begin using IMPROVE within just a few days.</p><p>Once you’ve completed your Launch Programme you’ll be ready to go live with confidence.</p>"
        },
        {
          "question": "Is IMPROVE easy to use?",
          "answer": "<p>Yes.</p><p>IMPROVE has been designed by learning experts specifically for SMEs, making it intuitive and straightforward to use without requiring technical expertise.</p>"
        },
        {
          "question": "Can we upgrade later?",
          "answer": "<p>Absolutely.</p><p>As your organisation grows you can simply move to the next user package.</p>"
        }
      ]
    },
    {
      "title": "Support & Security",
      "items": [
        {
          "question": "What support do you provide?",
          "answer": "<p>Every customer has access to our UK-based support team.</p><p>If you need help simply email <a href=\"mailto:info@improve.online\">info@improve.online</a> and we’ll be happy to assist.</p>"
        },
        {
          "question": "Is our data secure?",
          "answer": "<p>Yes.</p><p>Your data is securely hosted on AWS London using enterprise-grade cloud infrastructure and protected using modern security and data protection practices.</p>"
        },
        {
          "question": "Can IMPROVE integrate with our HR system?",
          "answer": "<p>Yes.</p><p>IMPROVE integrates with a range of HR systems to simplify employee onboarding and user management.</p><p>If you’re unsure whether your HR system is supported, simply ask.</p>"
        },
        {
          "question": "Do you provide management development?",
          "answer": "<p>Yes.</p><p>Alongside the platform we offer Leadership Plus, our complete management and leadership development framework.</p><p>Leadership Plus includes programmes for:</p><ul><li>Aspiring Managers</li><li>First Line Managers</li><li>Mid-Senior Managers</li><li>Directors</li></ul><p>Selected programmes are also available as ILM-accredited qualifications.</p>"
        }
      ]
    },
    {
      "title": "Choosing the Right Solution",
      "items": [
        {
          "question": "How do I know if IMPROVE is right for my organisation?",
          "answer": "<p>If you’re looking for a simple, affordable way to manage onboarding, compliance and employee development, without the complexity of a traditional enterprise LMS, IMPROVE is designed for you.</p>"
        },
        {
          "question": "Should I buy IMPROVE online or take the free trial?",
          "answer": "<p>There are two ways to get started.</p><p><strong>Buy IMPROVE</strong></p><p>Perfect if you’ve watched the demo and you’re ready to get started immediately.</p><p><strong>Experience IMPROVE</strong></p><p>Ideal if you’d like to take a free trial and explore the platform before making a decision.</p><p>You’ll also have the opportunity to join one of our live webinars and ask any questions before purchasing.</p>"
        },
        {
          "question": "How long does implementation take?",
          "answer": "<p>Most organisations are ready to start using IMPROVE within a few days.</p><p>Our Launch Programme ensures you’re fully prepared before going live.</p>"
        },
        {
          "question": "What if my business grows?",
          "answer": "<p>No problem.</p><p>Simply upgrade to the next package whenever your organisation grows.</p>"
        },
        {
          "question": "Can I cancel my subscription?",
          "answer": "<p>IMPROVE is provided on a three-year agreement, giving you price certainty while supporting long-term workforce development.</p><p>We’ll always contact you well before your renewal date to discuss your future plans.</p>"
        }
      ]
    }
  ],
  "steps": [
    {
      "title": "Purchase Online",
      "body": "<p>Choose the package that’s right for your organisation and complete your secure online purchase.</p>"
    },
    {
      "title": "Welcome to IMPROVE",
      "body": "<p>You’ll receive a welcome email confirming your purchase together with your account details and next steps.</p>"
    },
    {
      "title": "Complete Your IMPROVE Launch Programme",
      "body": "<p>One of our Customer Success Managers will arrange your online Launch Programme.</p><p>Together we’ll:</p><ul><li>Configure your platform</li><li>Discuss your objectives</li><li>Set up users</li><li>Review your learning content</li><li>Plan your launch</li></ul>"
    },
    {
      "title": "Go Live",
      "body": "<p>Once your Launch Programme is complete you’ll be ready to start onboarding employees, assigning learning and tracking progress.</p>"
    },
    {
      "title": "Grow With IMPROVE",
      "body": "<p>As your organisation develops you can continue uploading your own content, creating learning pathways, adding new employees and expanding into management and leadership development through Leadership Plus.</p>"
    }
  ],
  "ctas": [
    {
      "title": "Buy IMPROVE",
      "body": "Purchase IMPROVE securely online and get started today.",
      "to": "/get-started"
    },
    {
      "title": "Watch the 4-minute demo",
      "body": "See how growing businesses are improving onboarding, compliance and employee development with IMPROVE.",
      "to": "/watch-demo"
    },
    {
      "title": "Experience IMPROVE",
      "body": "Take a free trial and explore the platform at your own pace before making a decision.",
      "to": "experience"
    }
  ],
  "still": "If you can’t find the answer you’re looking for, our team will be happy to help."
};
